import * as React from "react";

import * as router from "@client/router";

import * as forms from "@client/site/forms";
import {server} from "@reactivated";

export const InviteUser = router.InviteUser.withHooks(() => {
    return {
        form: forms.useAutoPform(server.core.rpc.InviteUser),
    };
})
    .withIndex((props) => (
        <div style={{display: "flex", gap: 15, flexDirection: "column"}}>
            <p>
                Just enter an email address below and we'll send instructions to the
                person you invited!
            </p>
            <forms.PField field={props.form.fields.email} />
        </div>
    ))
    .withActions((props) => [
        {
            icon: "send",
            title: "Invite",
            onClick: async () => {
                const result = await forms.submitForm(
                    server.core.rpc.invite_user,
                    props.form.values,
                    props.form,
                );
                if (result.type === "success") {
                    props.notify(
                        "Your invitation was sent! Feel free to invite other users.",
                    );
                    props.form.reset();
                    void props.analytics.track("INVITE_USER_SUCCESS");
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Invite user",
    }));
